import { READ_ALOUD_SWITCH_CLASSES } from '../constants/classNames';
import { joinClassNames } from '../utils/classNameUtils';
import '../styles/ReadAloudSwitch.css';

/**
 * On/off switch for Fizzy reading messages aloud. Uses the standard ARIA switch
 * pattern: a button with role="switch" and aria-checked, operable by click, Enter or Space.
 */
export default function ReadAloudSwitch({ isOn, isAvailable, onToggle }) {
  const stateLabel = isOn ? 'On' : 'Off';
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isOn}
      disabled={!isAvailable}
      title={isAvailable ? undefined : "This browser can't read aloud"}
      className={joinClassNames(READ_ALOUD_SWITCH_CLASSES.root, isOn && READ_ALOUD_SWITCH_CLASSES.on)}
      onClick={onToggle}
    >
      <span className={READ_ALOUD_SWITCH_CLASSES.icon} aria-hidden="true">
        🔊
      </span>
      <span className={READ_ALOUD_SWITCH_CLASSES.label}>Read to me</span>
      <span className={READ_ALOUD_SWITCH_CLASSES.track} aria-hidden="true">
        <span className={READ_ALOUD_SWITCH_CLASSES.thumb} />
      </span>
      <span className={READ_ALOUD_SWITCH_CLASSES.state} aria-hidden="true">
        {stateLabel}
      </span>
    </button>
  );
}
